import { ToteNamingConfigSchema } from "@redotech/redo-fulfillment-wms-common/tote-naming-config";
import { processingGroupIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const updateProcessingGroup = {
  name: "updateProcessingGroup" as const,
  input: z.object({
    id: processingGroupIdFormat.schema,
    name: z.string(),
    toteNamingConfig: ToteNamingConfigSchema.optional(),
  }),
  output: z.null(),
};
